export Tick from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_tick.svg';
export Move from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_move.svg';
export Expand from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_dropdown.svg';
export Collapse from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_up_solid.svg';
export Cross from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_cross.svg';
export Edit from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_edit.svg';
export Visible from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_visible.svg';
export Hidden from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_hidden.svg';
export Preview from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_preview.svg';
export Right from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_right_solid.svg';
export Left from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_left_solid.svg';
export Up from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_up.svg';
export Down from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_down.svg';
export Warning from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_warning.svg';
export Delete from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_delete.svg';



// WEBPACK FOOTER //
// ./app/helpers/icon-dictionary.js